import { Link } from 'react-router-dom'

import { classNames, formatDate } from '@/lib/misc/Utils'
import { LEGAL_LINKS } from '@/lib/definitions/constants'
import build from '@/build-info.json'
import CodeBracketIcon from '@icons/command-line'

interface FooterPropsInterface {
  className?: string
}

const Footer = ({ className }: FooterPropsInterface) => (
  <div
    className={classNames(
      'flex flex-col space-y-4 md:space-y-0 md:flex-row items-center justify-between w-full pt-1 py-4 text-neutral-50 sm:py-4',
      className
    )}
  >
    <div className="text-xs text-neutral-50 flex items-center space-x-2">
      <CodeBracketIcon className="size-4" />
      <span>
        {!!build?.time ? `Build ${formatDate(build.time * 1000)}` : ''}
      </span>
    </div>

    <div className="mt-2 sm:mt-0 text-center flex flex-col space-y-4 md:flex-row md:space-y-0 md:space-x-2">
      <span className="text-neutral-50 flex flex-col space-y-2 md:flex-row md:space-y-0">
        <span>All prices without VAT</span>
        <span className="mx-2 text-2xs hidden md:inline-block">•</span>
        <span>All rights reserved</span>
      </span>

      <div className="grid grid-cols-3 gap-2 sm:flex items-center">
        <span className="mr-2 text-neutral-50 text-2xs hidden md:inline-block">
          •
        </span>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://inter.link/imprint/"
          className="text-link-default hover:text-text-link max-md:py-2.5"
        >
          Imprint
        </a>
        <span className="mx-2 text-neutral-50 text-2xs hidden md:inline-block">
          •
        </span>
        <Link
          target="_blank"
          rel="noopener noreferrer"
          to="/legal/privacy"
          className="text-link-default hover:text-text-link max-md:py-2.5"
        >
          Privacy
        </Link>
        <span className="mx-2 text-neutral-50 text-2xs hidden md:inline-block">
          •
        </span>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={LEGAL_LINKS.TERMS_OF_SERVICE_SLA}
          className="text-link-default hover:text-text-link max-md:py-2.5"
        >
          Terms
        </a>
        <span className="mx-2 text-neutral-50 text-2xs hidden md:inline-block">
          •
        </span>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="/map"
          className="text-link-default hover:text-text-link col-span-3 max-md:py-2.5"
        >
          Explore the network
        </a>
      </div>
    </div>
  </div>
)

export default Footer
